import React from 'react';
import { useParams } from 'react-router-dom';
import { TreePlantingContextProvider } from './TreeplantingContext';
import TreePlantingV1 from './v1/index';
import TreePlantingV2 from './v2/index';
import env from '../env';

interface urlParams extends Record<string, string | undefined> {
  partner?: string;
}

interface PartnerMapping {
  [partnerName: string]: {
    version: number;
    partnerId: string;
  };
}

const partnerMapping: PartnerMapping = {
  etisalat: {
    version: 2,
    partnerId: env.etisalat_partner_id,
  },
};

const TreePlanting: React.FC = () => {
  const urlParams = useParams<urlParams>();
  const partnerName = urlParams?.partner;
  const partnerDetails = partnerName ? partnerMapping[partnerName] : null;
  const partnerId = partnerDetails?.partnerId ?? env.kindred_partner_id;

  const renderTreePlantingContent = () => {
    switch (partnerDetails?.version) {
      case 1:
        return <TreePlantingV1 />;

      case 2:
        return <TreePlantingV2 />;

      default:
        return <TreePlantingV1 />;
    }
  };

  return (
    <TreePlantingContextProvider partnerId={partnerId}>
      {renderTreePlantingContent()}
    </TreePlantingContextProvider>
  );
};

export default TreePlanting;
